import { Link } from 'react-router-dom';
import { ArrowRight, Play, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const LandingCta = () => (
  <section className="bg-primary py-16">
    <div className="max-w-6xl mx-auto px-6 text-center">
      <h2 className="text-2xl md:text-3xl font-bold text-white">
        Icarus D&D als Praxis-MVP starten
      </h2>
      <p className="text-white/80 mt-3 max-w-md mx-auto">
        Dokumentation, Teletherapie, Portal und Verwaltung in einer Schaltzentrale.
        Der Mensch entscheidet, Icarus D&D bereitet vor.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <a href="mailto:info@icarus-health.de?subject=Demo-Anfrage%20D%3AE%3AF%3AY">
          <Button size="lg" className="bg-white text-primary hover:bg-white/90 rounded-xl text-base px-6 h-12 font-semibold">
            <MessageSquare className="w-4 h-4 mr-2" />
            Demo anfragen
          </Button>
        </a>
        <Link to="/login">
          <Button size="lg" className="bg-white/90 text-primary hover:bg-white rounded-xl text-base px-6 h-12 font-semibold">
            <Play className="w-4 h-4 mr-2" />
            Icarus D&D-Demo starten
          </Button>
        </Link>
        <Link to="/login">
          <Button size="lg" className="bg-white/85 text-primary hover:bg-white rounded-xl text-base px-6 h-12 font-semibold">
            Login
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);
